import store from 'store';
import { validateField } from '../../../utils/FormValidations'



export const START_VALIDATOR = '[VALIDATOR] START_VALIDATOR';
export const RUN_VALIDATOR = '[VALIDATOR] RUN_VALIDATOR';

export function startValidator(list) {
    return (dispatch) => {
        dispatch({
            type: START_VALIDATOR,
            payload: list
        })
    }
}

export function runValidator(data) {
    const currentValidator = store.getState().validator.list;
    let validatorRow = currentValidator.filter(v => v.field_name === data.field_name)[0]
    if (!validatorRow) {
        validatorRow = {functionName: []}
    }
    else {
        validatorRow = { ...validatorRow, value: data.value }
    }

    return async (dispatch) => {
        const results = await Promise.all(validatorRow.functionName.map(async (func) => {
            return await validateField(validatorRow, func)
        }))
        dispatch({
            type: RUN_VALIDATOR,
            payload: {results, field_name: data.field_name}
        })
    }
}




// WEBPACK FOOTER //
// src/main/components/validator/store/actions/validator.actions.js